/* Me & My — Account popup controller.
   Opens #mm-auth from any [data-mm-auth-open] trigger and closes on the close
   button, backdrop click, or Esc (native <dialog>). The popup itself just hands
   off to Shopify's hosted sign-in, so there's no form handling here. */
(function () {
  var dialog = document.getElementById('mm-auth');
  if (!dialog) return;

  function open() {
    if (dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }
  function close() {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mm-auth-open]');
    if (opener) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-mm-auth-close]')) { close(); }
  });

  // Click on the backdrop (outside the box) closes.
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });
})();
